import type React from "react";
import { ReactComponent as Svg } from "./assets/buy.svg";
import * as styles from "./Icon.module.scss";

type BuyProps = React.SVGProps<SVGSVGElement>;

export const Buy = ({ className, ...props }: BuyProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
